import { forwardRef } from 'react';
import { StyledButton, StyledDeleteIcon, StyledLabel } from './pill-tab-list-item.styled';

import { DismissDefault12Px } from '@galaxy-react/core';

import type { ButtonProps } from '@galaxy-react/core';

export type PillTabListItemProps = ButtonProps & {
  label: string;
  hasDeleteIcon?: boolean;
  isSelected?: boolean;
  handleDelete?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

export type PillTabListItemRef = HTMLButtonElement;

export const PillTabListItem = forwardRef<PillTabListItemRef, PillTabListItemProps>(function PillTabListItem(
  props: PillTabListItemProps,
  PillTabListItemRef,
) {
  return (
    <StyledButton
      className="pill-tab-list-item"
      ref={PillTabListItemRef}
      {...props}
      shape="circular"
      iconPosition="before"
    >
      <StyledLabel data-label={props.label}>{props.label}</StyledLabel>
      {props.hasDeleteIcon && (
        <StyledDeleteIcon appearance="transparent" isSelected={props.isSelected} onClick={props.handleDelete} as="a">
          <DismissDefault12Px id="delete-icon" />
        </StyledDeleteIcon>
      )}
    </StyledButton>
  );
});
